import { TAny, IAppExtras } from '../models/common.type';
import { IAppConfig } from './../models/app-config.model';

export class AppConfig implements IAppConfig {

    userId: string = '';
    userName: string = '';
    courtId: string = '';
    hostUrl: string = '';
    isProd: boolean = false;
    token: string | null = null;
    noOfAttempts: number = 1;
    extras: IAppExtras = {};


    constructor(model?: IAppConfig) {
        if (model) {
            this.userId = model.userId;
            this.userName = model.userName;
            this.courtId = model.courtId;
            this.hostUrl = model.hostUrl;
            this.isProd = model.isProd;
            this.noOfAttempts = model.noOfAttempts;
            this.token = model.token;
        }
    }

    public getExtras<T>() {
        return this.extras as T;
    }

    public setProp(prop: string, value: string | string[]) {
        if (prop in this) {
            (this as TAny)[prop] = value;
        }
    }

    public setExtransProp(prop: string, value: string | number) {
        if (prop in this.extras) {
            (this.extras)[prop] = value;
        }
    }


}